import React from "react";
import { motion, MotionValue } from "framer-motion";

interface ProgressBarProps {
  scrollYProgress: MotionValue<number>;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ scrollYProgress }) => {
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 origin-left z-50"
      style={{ scaleX: scrollYProgress }}
    />
  );
};

export default ProgressBar;
